var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.59 1.07036C10.2858 0.759523 9.75 0.730357 9.41084 1.07036L3.5775 6.90286C3.25167 7.22869 3.25167 7.75536 3.5775 8.08119C3.90334 8.40702 4.43084 8.40702 4.75584 8.08119L9.16667 3.67036V15.4995C9.16667 15.9595 9.54 16.3329 10 16.3329C10.4608 16.3329 10.8333 15.9595 10.8333 15.4995V3.67036L15.2442 8.08119C15.57 8.40702 16.0975 8.40702 16.4225 8.08119C16.7483 7.75536 16.7483 7.22869 16.4225 6.90286L10.59 1.07036Z",
    fill: "#CCCCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1667 14.7578C18.7058 14.7578 18.3333 15.1311 18.3333 15.5911V17.1853C18.3333 18.0553 17.5992 19.1595 16.775 19.1595H3.22417C2.4 19.1595 1.66667 18.0553 1.66667 17.1853V15.5911C1.66667 15.1311 1.29333 14.7578 0.833333 14.7578C0.3725 14.7578 0 15.1311 0 15.5911V17.1853C0 18.9045 1.37833 20.8261 3.22417 20.8261H16.775C18.6208 20.8261 20 18.9045 20 17.1853V15.5911C20 15.1311 19.6267 14.7578 19.1667 14.7578Z",
    fill: "#CCCCCC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Upload_icon.3f005d64c9626e68426b3c1e771de937.svg";